import { Button, Stack } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

export default function FooterModal({ submit, disabled, label }: { submit: Function, disabled?: boolean, label: string }) {
  return (
    <footer className="modal-card-foot">
      <Stack
        width={'100%'}
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Button
          endIcon={<SaveIcon />}
          disabled={disabled}
          className="button is-success"
          onClick={() => submit()}>
          {label}
        </Button>
      </Stack>
    </footer>
  );
}
